export const CommissionStatementConstant = {
    currentCommissionStatement: 'Current Commission Statement',
    priorCommissionStatementArchived: 'Prior Commission Statement Archived',
    dateFrom: 'Date From',
    dateTo: 'Date To'
};